import { render } from "./OfertaLiveView.vue?vue&type=template&id=347b044f&scoped=true"
import script from "./OfertaLiveView.vue?vue&type=script&lang=js"
export * from "./OfertaLiveView.vue?vue&type=script&lang=js"

import "./OfertaLiveView.vue?vue&type=style&index=0&id=347b044f&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347b044f"]])

export default __exports__